import React from 'react';
import { useParams } from 'react-router-dom';
import {useCreateCompanyMutation, useGetCompanyQuery, useUpdateCompanyMutation} from "apis/companiesApi";
import FormModal from "components/modals/FormModal";
import {InputText} from "primereact/inputtext";
import PhoneInput from "react-phone-number-input";
import {Dropdown} from "primereact/dropdown";
import states from "data/states.json";
import {InputNumber} from "primereact/inputnumber";
import _ from "lodash";
import {Divider} from "primereact/divider";

const CompanyModal = () => {
    const { company } = useParams();
    const {data: editCompany, isFetching} = useGetCompanyQuery(company);
    const [createCompany] = useCreateCompanyMutation();
    const [updateCompany] = useUpdateCompanyMutation();

    const handleSubmit = (data) => {
        if(!data.id || data.id === 'new') {
            const clonedData = _.cloneDeep(data);

            clonedData.address1 = clonedData.address1 || "";
            clonedData.address2 = clonedData.address2 || "";
            clonedData.city = clonedData.city || "";
            clonedData.state = clonedData.state || "";
            clonedData.zipCode = clonedData.zipCode || "";

            createCompany(clonedData);
        }
        else {
            updateCompany(data)
        }
    }

    if(isFetching) {
        return (<></>);
    }
    else {
        return (<FormModal type="Company" editObject={editCompany || {name: ''}} handleSubmit={handleSubmit}
            renderForm={(formik) =>
                (<form onSubmit={formik.handleSubmit} className="formgrid grid">
                    <div className="field col-12">
                        <span className="p-float-label">
                            <InputText id="name" name="name" className="inputfield w-full" value={formik.values?.name} onChange={formik.handleChange} autoFocus />
                            <label htmlFor="name">Name</label>
                        </span>
                    </div>
                    {editCompany?.id === '' && <>
                        <Divider />
                        <h2>Main Office Location</h2>
                        <div className="field col-12">
                            <span className="p-float-label">
                                <InputText id="address1" name="address1" className="inputfield w-full" value={formik.values?.address1} onChange={formik.handleChange} />
                                <label htmlFor="address1">Address 1</label>
                            </span>
                        </div>
                        <div className="field col-12">
                            <span className="p-float-label">
                                <InputText id="address2" name="address2" className="inputfield w-full" value={formik.values?.address2} onChange={formik.handleChange} />
                                <label htmlFor="address2">Address 2</label>
                            </span>
                        </div>
                        <div className="field col-12 city-state-zip flex">
                            <span className="p-float-label city-input">
                                <InputText id="city" name="city" className="inputfield w-full" value={formik.values?.city} onChange={formik.handleChange} />
                                <label htmlFor="city">City</label>
                            </span>
                            <span className="p-float-label state-input">
                                <Dropdown name="state" value={formik.values?.state} options={states} onChange={formik.handleChange} optionLabel="name" optionValue="code" placeholder="Select a State" />
                            </span>
                            <span className="p-float-label zipcode-input">
                                <InputText id="zipCode" name="zipCode" className="inputfield w-full" value={formik.values?.zipCode} onChange={formik.handleChange} />
                                <label htmlFor="zipCode">Zip Code</label>
                            </span>
                        </div>
                        <Divider />
                    </>}
                    <div className="field col-12">
                        <span className="p-float-label">
                            <PhoneInput placeholder="Phone Number" defaultCountry="US" value={formik.values?.phoneNumber} onChange={(value) => formik.setFieldValue("phoneNumber", value, false)} />
                        </span>
                    </div>
                    <div className="field col-12">
                        <span className="p-float-label">
                            <InputText id="typeOfBusiness" name="typeOfBusiness" className="inputfield w-full" value={formik.values?.typeOfBusiness} onChange={formik.handleChange} />
                            <label htmlFor="typeOfBusiness">Type of Business</label>
                        </span>
                    </div>
                    <div className="field col-12">
                        <span className="p-float-label">
                            <InputNumber id="revenueProjection" name="revenueProjection" className="inputfield w-4" value={formik.values?.revenueProjection} onValueChange={formik.handleChange} mode="currency" currency="USD" locale="en-US"  />
                            <label htmlFor="revenueProjection">Revenue Projection (this year)</label>
                        </span>
                    </div>
                    <div className="field col-12">
                        <span className="p-float-label">
                            <InputNumber id="revenueLastYear" name="revenueLastYear" className="inputfield w-4" value={formik.values?.revenueLastYear} onValueChange={formik.handleChange} mode="currency" currency="USD" locale="en-US"  />
                            <label htmlFor="revenueLastYear">Revenue (previous year)</label>
                        </span>
                    </div>
                    <div className="field col-12">
                        <span className="p-float-label">
                            <InputNumber id="revenueTwoYears" name="revenueTwoYears" className="inputfield w-4" value={formik.values?.revenueTwoYears} onValueChange={formik.handleChange} mode="currency" currency="USD" locale="en-US"  />
                            <label htmlFor="revenueTwoYears">Revenue (2 years prior)</label>
                        </span>
                    </div>
                    <div className="field col-12">
                        <span className="p-float-label">
                            <InputNumber id="totalNumberOfEmployees" name="totalNumberOfEmployees" className="inputfield w-4" value={formik.values?.totalNumberOfEmployees} onValueChange={formik.handleChange} maxFractionDigits={0} />
                            <label htmlFor="totalNumberOfEmployees">Total # of Employees</label>
                        </span>
                    </div>
                </form>)
            }>
        </FormModal>)
    }
}

export default CompanyModal;